import { FaCheck } from "react-icons/fa";
import { Link } from "react-router-dom";
import { FaAngleLeft } from "react-icons/fa6";
import toast from "react-hot-toast";
import Modal from "react-responsive-modal";
import FloatingLabelInput from "../../Common/FloatingLabel";
import { useEffect, useState, useRef } from "react";
import { Toaster } from "react-hot-toast";
import Header from "../../Common/Header";
import Loader from "../../loader";
import { useFormik } from "formik";
import * as Yup from "yup";
import { GetGift } from "../../api/get";
import {
  SaveBeneficiaryGift,
  SaveCharityGift,
  EditBeneficiaryGift,
  EditCharityGift,
} from "../../api/api";
import {
  RemoveBeneficiryGift,
  RemoveCharityGift,
  EstateBeneficiarySetList,
} from "../../api/get";
import { FaChevronRight } from "react-icons/fa";
import Spinner from "../../Common/Spinner";
import { handleApiError } from "../../Common/Helper";
import { useNavigate } from "react-router-dom";
const ListGiftCompo = () => {
  const [CharityModel, setCharityModel] = useState(false);
  const [BeneficiaryModel, setBeneficiaryModel] = useState(false);
  const [BeneficiaryGiftData, setBeneficiaryGiftData] = useState([]);
  const [refresh, setRefresh] = useState(false); // Track changes
  const [contentLoader, setContentLoader] = useState(true);
  const [GiftData, setGiftData] = useState([]);
  const [radio, setRadio] = useState(0);
  const [selectedGift, setSelectedGift] = useState(null);
  const [loading, setLoading] = useState(false);
  const [BeneficiaryModelEditMode, setBeneficiaryModelEditMode] =
    useState(false);
  const [CharityModelEditMode, setCharityModelEditMode] = useState(false);
  const [EstateBeneficiaryData, setEstateBeneficiary] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    GetGift()
      .then((res) => {
        if (res.success && res.status_code === "200") {
          setGiftData(res.data);
          setContentLoader(false);
        } else {
          handleApiError(res, navigate); // Use helper function
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, [refresh]);
  useEffect(() => {
    EstateBeneficiarySetList()
      .then((res) => {
        if (res.success && res.status_code === "200") {
          setEstateBeneficiary(res.data);
          setContentLoader(false);
        } else {
          handleApiError(res, navigate); // Use helper function
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  console.log("radio =>", radio);
  // console.log("selectedGift =>", selectedGift);

  const openGift = (giftData) => {
    giftData?.charity_name ? setCharityModel(true) : setBeneficiaryModel(true);
    if (giftData?.charity_name) {
      setCharityModel(true);
      // formikCharity.setValues({
      //   charity_name: giftData.charity_name,
      //   charity_id: giftData.charity_id,
      //   type_of_gift: giftData.type_of_gift
      //     ? giftData.type_of_gift
      //     : "possession",
      // });
      setSelectedGift(giftData);
    } else {
      setBeneficiaryModel(true);
      setSelectedGift(giftData);
      // formik.setValues({
      //   beneficiary_first_name: giftData.beneficiary_first_name,
      //   beneficiary_last_name: giftData.beneficiary_last_name,
      //   beneficiary_id: giftData.beneficiary_id,
      // });
    }
  };
  const validationSchemaForBeneficiary = Yup.object().shape({
    beneficiary_id: Yup.string().notRequired(),
    type_of_gift: Yup.string()
      .required("Gift type is required")
      .oneOf(["possession", "money"], "Invalid gift type"),
    gift_description: Yup.string().when("type_of_gift", {
      is: (value) => value === "possession",
      then: () => Yup.string().required("Required field"),
      otherwise: () => Yup.string().notRequired(),
    }),
    leave_money_amount: Yup.string().when("type_of_gift", {
      is: (value) => value === "money",
      then: () =>
        Yup.string()
          .required("Required field")
          .matches(/^\d+$/, "Must be a positive number")
          .test(
            "is-positive",
            "Must be greater than zero",
            (value) => !value || parseInt(value, 10) > 0
          ),
      otherwise: () => Yup.string().notRequired(),
    }),
  });
  const formik = useFormik({
    initialValues: {
      // beneficiary_id: selectedGift?.beneficiary_id || "",
      // type_of_gift: "possession", // Either "possession" or "money"
      // gift_description: "",
      // leave_money_amount: "",
      // message: "",
      beneficiary_id: selectedGift?.beneficiary_id || "",
      type_of_gift: selectedGift?.type_of_gift || "possession",
      gift_description: selectedGift?.gift_description || "",
      leave_money_amount: selectedGift?.leave_money_amount || "",
      message: selectedGift?.message || "",
    },
    validationSchema: validationSchemaForBeneficiary,
    enableReinitialize: true,
    onSubmit: async (values, { resetForm }) => {
      setLoading(true);
      if (BeneficiaryModelEditMode) {
        EditBeneficiaryGift(values)
          .then((res) => {
            if (res.success && res.status_code === "200") {
              toast.success("Gift Updated Successfully");
              resetForm(); // This will clear the form fields
              setRefresh((prev) => !prev);
              setBeneficiaryModel(false);
              onCloseBeneficiaryModel();
              setLoading(false);
            } else {
              handleApiError(res, navigate);
            }
          })
          .catch((err) => {
            setLoading(false);
            toast.error("An error occurred");
            console.log(err);
          });
      } else {
        SaveBeneficiaryGift(values)
          .then((res) => {
            if (res.success && res.status_code === "200") {
              toast.success("Gift Added Successfully");
              resetForm(); // This will clear the form fields
              setRefresh((prev) => !prev);
              setBeneficiaryModel(false);
              onCloseBeneficiaryModel();
              setLoading(false);
              // navigate("/make-will-online/about-yourself/partner");
            } else {
              handleApiError(res, navigate);
            }
          })
          .catch((err) => {
            setLoading(false);
            toast.error("An error occurred");
            console.log(err);
          });
      }
    },
  });
  const validationSchemaForCharity = Yup.object().shape({
    charity_id: Yup.string().notRequired(),
    type_of_gift: Yup.string()
      .required("Gift type is required")
      .oneOf(["possession", "money"], "Invalid gift type"),
    gift_description: Yup.string().when("type_of_gift", {
      is: (value) => value === "possession",
      then: () => Yup.string().required("Required field"),
      otherwise: () => Yup.string().notRequired(),
    }),
    leave_money_amount: Yup.string().when("type_of_gift", {
      is: (value) => value === "money",
      then: () =>
        Yup.string()
          .required("Required field")
          .matches(/^\d+$/, "Must be a positive number")
          .test(
            "is-positive",
            "Must be greater than zero",
            (value) => !value || parseInt(value, 10) > 0
          ),
      otherwise: () => Yup.string().notRequired(),
    }),
  });
  const formikCharity = useFormik({
    initialValues: {
      // charity_id: selectedGift?.charity_id || "",
      // type_of_gift: "possession", // Either "possession" or "money"
      // gift_description: "",
      // leave_money_amount: "",
      // message: "",
      charity_id: selectedGift?.charity_id || "",
      type_of_gift: selectedGift?.type_of_gift || "possession",
      gift_description: selectedGift?.gift_description || "",
      leave_money_amount: selectedGift?.leave_money_amount || "",
      message: selectedGift?.message || "",
    },
    validationSchema: validationSchemaForCharity,
    enableReinitialize: true,
    onSubmit: async (values, { resetForm }) => {
      console.log("vaaa l l  -> ", values);
      setLoading(true);
      if (CharityModelEditMode) {
        EditCharityGift(values)
          .then((res) => {
            if (res.success && res.status_code === "200") {
              toast.success("Gift updated Successfully");
              resetForm(); // This will clear the form fields
              setRefresh((prev) => !prev);
              setCharityModel(false);
              onCloseCharityModel();
              setLoading(false);
              // navigate("/make-will-online/about-yourself/partner");
            } else {
              handleApiError(res, navigate);
            }
          })
          .catch((err) => {
            // setLoading(false);
            toast.error("An error occurred");
            console.log(err);
          });
      } else {
        SaveCharityGift(values)
          .then((res) => {
            if (res.success && res.status_code === "200") {
              toast.success("Gift Added Successfully");
              resetForm(); // This will clear the form fields
              setRefresh((prev) => !prev);
              setCharityModel(false);
              onCloseCharityModel();
              setLoading(false);
              // navigate("/make-will-online/about-yourself/partner");
            } else {
              handleApiError(res, navigate);
            }
          })
          .catch((err) => {
            // setLoading(false);
            toast.error("An error occurred");
            console.log(err);
          });
      }
    },
  });
  useEffect(() => {
    if (selectedGift) {
      formik.setValues((prevValues) => ({
        ...prevValues,
        beneficiary_id: selectedGift.beneficiary_id || "",
      }));
      formikCharity.setValues((prevValues) => ({
        ...prevValues,
        charity_id: selectedGift.charity_id || "",
      }));
    }
  }, [selectedGift]);

  const onCloseBeneficiaryModel = () => {
    setBeneficiaryModel(false);
    setBeneficiaryModelEditMode(false);
    setRadio(0);
    formik.resetForm(); // Reset the form on modal close
    setSelectedGift(null);
  };
  const onCloseCharityModel = () => {
    setCharityModel(false);
    setCharityModelEditMode(false);
    setRadio(0);
    // alert("666");
    formikCharity.resetForm(); // Reset the form on modal close
    setSelectedGift(null);
  };
  const handleEditBeneficiary = (data) => {
    setBeneficiaryModel(true);
    setBeneficiaryModelEditMode(true);
    if (data.type_of_gift === "money") {
      setRadio(1);
    } else {
      setRadio(0);
    }
    setSelectedGift(data);
    formik.setValues({
      beneficiary_first_name: data.beneficiary_first_name,
      beneficiary_last_name: data.beneficiary_last_name,
      beneficiary_id: data.beneficiary_id,
      type_of_gift: data.type_of_gift,
      gift_description: data.gift_description,
      leave_money_amount: data.leave_money_amount,
      message: data.message,
      beneficiars_gifts_id: data.beneficiars_gifts_id,
    });
  };
  const handleEditCharity = (data) => {
    console.log("data =>", data);
    setCharityModel(true);
    setCharityModelEditMode(true);
    setRadio(data.type_of_gift === "money" ? 1 : 0);
    setSelectedGift(data);

    formikCharity.setValues({
      charity_name: data.charity_name,
      charity_id: data.charity_id,
      type_of_gift: data.type_of_gift,
      gift_description: data.gift_description,
      leave_money_amount: data.leave_money_amount,
      message: data.message,
      charity_gifts_id: data.charity_gifts_id,
    });
  };
  const RemoveBeneficiryGiftFunction = (beneficiars_gifts_id) => {
    RemoveBeneficiryGift(beneficiars_gifts_id)
      .then((res) => {
        if (res.success && res.status_code === "200") {
          toast.success("Gift removed successfully");
          setRefresh((prev) => !prev); // Trigger refresh after deletion
          onCloseBeneficiaryModel();
        } else {
          handleApiError(res, navigate);
        }
      })
      .catch(() => toast.error("Failed to remove child"));
  };
  const RemoveCharityGiftFunction = (charity_gifts_id) => {
    console.log("cha ss ->", charity_gifts_id);
    RemoveCharityGift(charity_gifts_id)
      .then((res) => {
        if (res.success && res.status_code === "200") {
          toast.success("Gift removed successfully");
          setRefresh((prev) => !prev); // Trigger refresh after deletion
          onCloseCharityModel();
        } else {
          handleApiError(res, navigate);
        }
      })
      .catch(() => toast.error("Failed to remove child"));
  };

  // console.log("formik =>", formik);
  console.log("formikCharity =>", formikCharity);
  return (
    <>
      {contentLoader ? (
        <Loader />
      ) : (
        <>
          <Toaster />
          <Header />
          <div className="container">
            <div className="grid grid-cols-2 mt-[15px] max-lg:grid-cols-1">
              <div>
                <div>
                  <p className="font-semibold text-[22px] sm:text-[24px] md:text-[26px] lg:text-[28px]">
                    Leave specific gifts
                  </p>
                  <p className="my-2 text-slate-500">
                    You can leave anything you own as a gift. Typically, these
                    are personal possessions such as a ring or music collection,
                    as well as set sums of money.
                  </p>
                  <p className="my-2 text-slate-500">
                    If you are thinking of gifting a property to someone, make
                    sure to ask us for advice - it isn’t always straightforward.
                  </p>
                  <p className="my-2 text-slate-500">
                    If there isn’t anything particular you want to leave, that’s
                    fine - this section is optional.
                  </p>
                </div>
                {GiftData?.charities?.map((item, index) => {
                  return (
                    <div className="my-5 w-full" key={index}>
                      <div className="border-[#d7d7d7] rounded-lg border-2 py-3 px-4 flex items-center justify-between">
                        <div className="flex items-center gap-5 w-full">
                          {/* Image Section */}
                          <div className="w-[15%] max-w-[100px]">
                            <img
                              src={item.charity_image}
                              alt={item.charity_name}
                              className="w-full h-auto object-cover rounded-md"
                            />
                          </div>

                          {/* Text Section */}
                          <div className="w-[55%]">
                            <h4 className="text-[16px] text-black font-muli font-bold">
                              {item.charity_name}
                            </h4>
                            <p>{item.charity_desc}</p>
                          </div>
                          {/* Button Section */}
                          <div className="w-[25%] flex justify-center">
                            <button
                              onClick={() => openGift(item)}
                              className="text-[14px] sm:text-[14px] md:text-[16px] lg:text-[16px] border-2 hover:bg-primary hover:text-white transition-all ease-in rounded-[5px] border-[#240642] text-[#240642] px-4 py-1 font-bold"
                            >
                              Leave a gift
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}

                {GiftData?.beneficiaries?.map((item, index) => {
                  return (
                    <div className="my-5 w-full" key={index}>
                      <div className="border-[#d7d7d7] rounded-lg border-2 py-3 px-4 flex items-center justify-between">
                        <div className="flex items-center gap-5 w-full">
                          <div className="w-[15%] max-w-[100px]">
                            <img
                              src="/assets/images/icon-mascot.png"
                              alt="eee"
                              className="w-full h-auto object-cover rounded-md"
                            />
                          </div>
                          <div className="w-[55%]">
                            <h4 className="text-[16px] text-black font-muli font-bold ">
                              {item.beneficiary_first_name}{" "}
                              {item.beneficiary_last_name}
                            </h4>
                            <p>{item.beneficiary_type}</p>
                          </div>
                          <div className="w-[25%] flex justify-center">
                            <button
                              onClick={() => openGift(item)}
                              className="text-[14px] sm:text-[14px] md:text-[16px] lg:text-[16px] border-2 hover:bg-primary hover:text-white transition-all ease-in rounded-[5px] border-[#240642] text-[#240642] px-4 py-1 font-bold"
                            >
                              Leave a gift
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}

                <div className="text-[25px] font-semibold mt-3">Gifts</div>
                {GiftData?.beneficiarsGift?.length === 0 &&
                  GiftData?.charityGift?.length === 0 && (
                    <div className=" text-gray-500 mt-2">
                      Gifts data Not Available
                    </div>
                  )}
                {GiftData?.beneficiarsGift?.map((item, index) => {
                  return (
                    <div className="my-5" key={index}>
                      <div className="border-[#d7d7d7] rounded-lg border-2 pb-3 px-4 ">
                        <div className="flex items-center justify-between mt-[16px]">
                          <div className="flex items-center gap-5">
                            <div>
                              <img src="/assets/images/icon-mascot.png" />
                            </div>
                            <div>
                              <h4 className="text-[16px] text-black font-muli font-bold ">
                                {item.beneficiary_first_name}{" "}
                                {item.beneficiary_last_name}
                              </h4>
                              <p className=" ">
                                {item?.type_of_gift === "possession"
                                  ? item.gift_description
                                  : item.leave_money_amount}{" "}
                              </p>
                            </div>
                          </div>
                          <div>
                            <button
                              onClick={() => handleEditBeneficiary(item)}
                              className="border-2 hover:bg-primary hover:text-white transition-all ease-in rounded-[5px] border-[#240642] text-[#240642] px-4 py-1 font-bold"
                            >
                              Edit
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
                {GiftData?.charityGift?.map((item, index) => {
                  return (
                    <div className="my-5" key={index}>
                      <div className="border-[#d7d7d7] rounded-lg border-2 pb-3 px-4 ">
                        <div className="flex items-center justify-between mt-[16px]">
                          <div className="flex items-center gap-5">
                            <div>
                              <img src="/assets/images/icon-mascot.png" />
                            </div>
                            <div>
                              <h4 className="text-[16px] text-black font-muli font-bold ">
                                {item.charity_name}
                              </h4>
                              <p className=" ">
                                {item?.type_of_gift === "possession"
                                  ? item.gift_description
                                  : item.leave_money_amount}{" "}
                              </p>
                            </div>
                          </div>
                          <div>
                            <button
                              onClick={() => handleEditCharity(item)}
                              className="border-2 hover:bg-primary hover:text-white transition-all ease-in rounded-[5px] border-[#240642] text-[#240642] px-4 py-1 font-bold"
                            >
                              Edit
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
                <div className="border-b-2 my-5"></div>
                <div className="pt-5 flex justify-between items-center">
                  <div className="flex  pb-5">
                    <Link
                      to={`/make-will-online/estate/inheritance/${
                        EstateBeneficiaryData[EstateBeneficiaryData.length - 1]
                          ?.id
                      }`}
                    >
                      <button className="flex items-center justify-center gap-1 font-semiold text-[20px] py-2 rounded-[10px] text-slate-500">
                        <FaAngleLeft />
                        Back
                      </button>
                    </Link>
                  </div>
                  <div className="flex  pb-5">
                    <Link to={"/dashboard"}>
                      <button className="bg-primary px-5 py-3 text-white font-muli font-semibold rounded-[5px] flex items-center gap-1">
                        Next <FaChevronRight />
                      </button>
                    </Link>
                  </div>
                </div>
              </div>

              <div>
                <div className="max-lg:hidden bg-no-repeat ">
                  <div className="fixed top-[100px] w-[500px] right-[6%]">
                    <img src="/assets/images/10.png" alt="mascot" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          {selectedGift && (
            <Modal
              open={CharityModel}
              onClose={onCloseCharityModel}
              classNames={{
                modal:
                  "rounded-[5px] p-5 w-[95%] sm:w-[70%] md:w-[70%] lg:w-[70%] !m-0 ", // Adjusting modal width
              }}
              center
            >
              <form onSubmit={formikCharity.handleSubmit}>
                <div className="m-5">
                  <div>
                    <p className="mt-2 text-sm sm:text-base">
                      Leave{" "}
                      {selectedGift?.charity_name
                        ? selectedGift?.charity_name
                        : `${selectedGift?.beneficiary_first_name} ${selectedGift?.beneficiary_last_name}`}{" "}
                      a gift
                    </p>

                    <h4 className="text-[20px] sm:text-[26px] text-black font-bold mt-[0px]">
                      Choose the type of gift
                    </h4>
                  </div>

                  <div>
                    <input
                      name="charity_id"
                      type="hidden"
                      value={selectedGift?.charity_id}
                    />
                  </div>

                  <div className="flex flex-wrap items-center gap-5 my-5">
                    <div className="w-full sm:w-[48%]">
                      <div
                        className={`border-[#d7d7d7] rounded-lg border-2 pb-3 px-4 currentDiv ${
                          radio == 0 ? "blueBorder" : `border-[#d7d7d7]`
                        }`}
                        onClick={() => {
                          setRadio(0);
                          formikCharity.setFieldValue(
                            "type_of_gift",
                            "possession"
                          );
                        }}
                      >
                        <div className="flex items-center justify-between mt-4">
                          <div className="flex items-center gap-5">
                            <div>
                              <img
                                src="/assets/images/icon-mascot.png"
                                alt="Mascot Icon"
                                className="w-10 h-10 sm:w-12 sm:h-12"
                              />
                            </div>
                            <div className="flex items-center gap-3">
                              <input
                                name="type_of_gift"
                                type="radio"
                                onClick={() => {
                                  setRadio(0);
                                  formikCharity.setFieldValue(
                                    "type_of_gift",
                                    "possession"
                                  );
                                }}
                                checked={radio === 0}
                                value={"possession"}
                                onChange={formikCharity.handleChange}
                                className="w-[20px] h-[20px]"
                              />
                              <h4 className="font-semibold text-sm sm:text-base">
                                Possession
                              </h4>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="w-full sm:w-[48%]">
                      <div
                        className={`border-[#d7d7d7] rounded-lg border-2 pb-3 px-4 currentDiv ${
                          radio == 1 ? "blueBorder" : `border-[#d7d7d7]`
                        }`}
                        onClick={() => {
                          setRadio(1);
                          formikCharity.setFieldValue("type_of_gift", "money");
                        }}
                      >
                        <div className="flex items-center justify-between mt-4">
                          <div className="flex items-center gap-5">
                            <div>
                              <img
                                src="/assets/images/icon-mascot.png"
                                alt="Mascot Icon"
                                className="w-10 h-10 sm:w-12 sm:h-12"
                              />
                            </div>
                            <div className="flex items-center gap-3">
                              <input
                                name="type_of_gift"
                                type="radio"
                                onClick={() => {
                                  setRadio(1);
                                  formikCharity.setFieldValue(
                                    "type_of_gift",
                                    "money"
                                  );
                                }}
                                checked={radio === 1}
                                value={"money"}
                                onChange={formikCharity.handleChange}
                              />
                              <h4 className="font-semibold text-sm sm:text-base">
                                Money
                              </h4>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {radio === 0 && (
                    <div className="mt-1 mb-4">
                      <div className="mb-2">
                        <h4 className="text-[16px] sm:text-[18px] text-black font-bold mb-[5px]">
                          Description of gift
                        </h4>
                        <p className="my-1 text-sm">
                          The gift description needs to be specific to the item.
                        </p>
                      </div>
                      <FloatingLabelInput
                        label="e.g. rolex with gold plate"
                        type="text"
                        name="gift_description"
                        id="gift_description"
                        value={formikCharity.values.gift_description}
                        onChange={formikCharity.handleChange}
                        onBlur={formikCharity.handleBlur}
                        error={
                          formikCharity.touched.gift_description &&
                          formikCharity.errors.gift_description
                        }
                      />
                    </div>
                  )}
                  {radio === 1 && (
                    <div className="mt-1 mb-4">
                      <div className="mb-2">
                        <h4 className="text-[16px] sm:text-[18px] text-black font-bold mb-[5px]">
                          How much would you like to leave?
                        </h4>
                        <p className="my-1 text-sm">
                          Amount of money in Australian Dollar
                        </p>
                      </div>
                      <FloatingLabelInput
                        label="Amount"
                        type="text"
                        id="leave_money_amount"
                        name="leave_money_amount"
                        value={formikCharity.values.leave_money_amount}
                        onChange={formikCharity.handleChange}
                        onBlur={formikCharity.handleBlur}
                        error={
                          formikCharity.touched.leave_money_amount &&
                          formikCharity.errors.leave_money_amount
                        }
                      />
                    </div>
                  )}

                  {(radio === 1 || radio === 0) && (
                    <div>
                      <div className="mb-2">
                        <h4 className="text-[16px] sm:text-[18px] text-black font-bold mb-[5px]">
                          Add a message (optional)
                        </h4>
                        <p className="my-1 text-sm">
                          Messages are not legally binding. These will be
                          included in the appendix.
                        </p>
                      </div>
                      <div>
                        <textarea
                          id="message"
                          name="message"
                          placeholder="Say a few words (e.g., for a wedding, flights, etc.)"
                          className="w-full border border-gray-300 rounded-[5px] p-3 text-black focus:outline-none focus:ring-2 focus:ring-primary"
                          rows="4"
                          value={formikCharity.values.message || ""}
                          onChange={formikCharity.handleChange}
                        />
                      </div>
                      <div className="flex items-center justify-between gap-3 py-5">
                        {/* Save Gift Button */}
                        <button
                          type="submit"
                          className="px-4 py-2 text-sm sm:text-base text-white font-bold bg-primary rounded flex items-center gap-1 hover:bg-primary-dark"
                        >
                          {loading ? "Saving..." : "Leave a Gift"}{" "}
                          {!loading ? <FaChevronRight /> : ""}
                        </button>

                        {/* Remove Gift Button (Conditional) */}
                        {CharityModelEditMode && (
                          <button
                            type="button"
                            onClick={() =>
                              RemoveCharityGiftFunction(
                                formikCharity.values.charity_gifts_id
                              )
                            }
                            className="px-4 py-2 text-sm sm:text-base text-black border border-[#240642] font-semibold rounded flex items-center gap-1 hover:bg-primary hover:text-white"
                          >
                            Remove gift
                          </button>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </form>
            </Modal>
          )}
          {selectedGift && (
            <Modal
              open={BeneficiaryModel}
              onClose={onCloseBeneficiaryModel}
              center
              classNames={{
                modal:
                  "rounded-[5px] p-5 w-[95%] sm:w-[70%] md:w-[70%] lg:w-[70%] !m-0 ", // Adjusting modal width
              }}
            >
              <form onSubmit={formik.handleSubmit}>
                <div className="m-5">
                  <div>
                    <p className="mt-2 text-sm sm:text-base">
                      Leave {selectedGift?.beneficiary_first_name}{" "}
                      {selectedGift?.beneficiary_last_name} a gift
                    </p>
                    <h4 className="text-[20px] sm:text-[26px] text-black font-bold mt-[0px]">
                      Choose the type of gift
                    </h4>
                  </div>
                  <div>
                    <input
                      name="beneficiary_id"
                      type="hidden"
                      value={selectedGift?.beneficiary_id}
                    />
                  </div>

                  <div className="flex flex-wrap items-center gap-5 my-5">
                    <div className="w-full sm:w-[48%]">
                      <div
                        className={`border-[#d7d7d7] rounded-lg border-2 pb-3 px-4 currentDiv ${
                          radio == 0 ? "blueBorder" : `border-[#d7d7d7]`
                        }`}
                        onClick={() => {
                          setRadio(0);
                          formik.setFieldValue("type_of_gift", "possession");
                        }}
                      >
                        <div className="flex items-center justify-between mt-4">
                          <div className="flex items-center gap-5">
                            <div>
                              <img
                                src="/assets/images/icon-mascot.png"
                                alt="Mascot Icon"
                                className="w-10 h-10 sm:w-12 sm:h-12"
                              />
                            </div>
                            <div className="flex items-center gap-3">
                              <input
                                name="type_of_gift"
                                type="radio"
                                onClick={() => {
                                  setRadio(0);
                                  formik.setFieldValue(
                                    "type_of_gift",
                                    "possession"
                                  );
                                }}
                                checked={radio === 0}
                                value={"possession"}
                                onChange={formik.handleChange}
                                className="w-[20px] h-[20px]"
                                id="possession"
                              />
                              <h4
                                className="font-semibold text-sm sm:text-base"
                                htmlFor="possession"
                              >
                                Possession
                              </h4>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="w-full sm:w-[48%]">
                      <div
                        className={`border-[#d7d7d7] rounded-lg border-2 pb-3 px-4 currentDiv ${
                          radio == 1 ? "blueBorder" : `border-[#d7d7d7]`
                        }`}
                        onClick={() => {
                          setRadio(1);
                          formik.setFieldValue("type_of_gift", "money");
                        }}
                      >
                        <div className="flex items-center justify-between mt-4">
                          <div className="flex items-center gap-5">
                            <div>
                              <img
                                src="/assets/images/icon-mascot.png"
                                alt="Mascot Icon"
                                className="w-10 h-10 sm:w-12 sm:h-12"
                              />
                            </div>
                            <div className="flex items-center gap-3">
                              <input
                                name="type_of_gift"
                                type="radio"
                                onClick={() => {
                                  setRadio(1);
                                  formik.setFieldValue("type_of_gift", "money");
                                }}
                                checked={radio === 1}
                                value={"money"}
                                onChange={formik.handleChange}
                                className="w-[20px] h-[20px]"
                              />
                              <h4 className="font-semibold text-sm sm:text-base">
                                Money
                              </h4>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {radio === 0 && (
                    <div className="mt-1 mb-4">
                      <div className="mb-2">
                        <h4 className="text-[16px] sm:text-[18px] text-black font-bold mb-[5px]">
                          Description of gift
                        </h4>
                        <p className="my-1 text-sm">
                          The gift description needs to be specific to the item.
                        </p>
                      </div>
                      <FloatingLabelInput
                        label="e.g. rolex with gold plate"
                        type="text"
                        name="gift_description"
                        id="gift_description"
                        value={formik.values.gift_description}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched.gift_description &&
                          formik.errors.gift_description
                        }
                      />
                    </div>
                  )}
                  {radio === 1 && (
                    <div className="mt-1 mb-4">
                      <div className="mb-2">
                        <h4 className="text-[16px] sm:text-[18px] text-black font-bold mb-[5px]">
                          How much would you like to leave?
                        </h4>
                        <p className="my-1 text-sm">
                          Amount of money in Australian Dollar
                        </p>
                      </div>
                      <FloatingLabelInput
                        label="Amount"
                        type="text"
                        id="leave_money_amount"
                        name="leave_money_amount"
                        value={formik.values.leave_money_amount}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched.leave_money_amount &&
                          formik.errors.leave_money_amount
                        }
                      />
                    </div>
                  )}
                  {(radio === 1 || radio === 0) && (
                    <div>
                      <div className="mb-2">
                        <h4 className="text-[16px] sm:text-[18px] text-black font-bold mb-[5px]">
                          Add a message (optional)
                        </h4>
                        <p className="my-1 text-sm">
                          Messages are not legally binding. These will be
                          included in the appendix.
                        </p>
                      </div>
                      <div>
                        <textarea
                          id="message"
                          name="message"
                          placeholder="Say a few words (e.g., for a wedding, flights, etc.)"
                          className="w-full border border-gray-300 rounded-[5px] p-3 text-black focus:outline-none focus:ring-2 focus:ring-primary"
                          rows="4"
                          value={formik.values.message || ""}
                          onChange={formik.handleChange}
                        />
                      </div>
                      <div className="flex items-center justify-between gap-3 py-5">
                        <button
                          type="submit"
                          className="px-4 py-2 text-sm sm:text-base text-white font-bold bg-primary rounded flex items-center gap-1 hover:bg-primary-dark"
                        >
                          {loading ? "Saving..." : "Leave a Gift"}{" "}
                          {!loading ? <FaChevronRight /> : ""}
                        </button>
                        {BeneficiaryModelEditMode && (
                          <button
                            type="button"
                            onClick={() =>
                              RemoveBeneficiryGiftFunction(
                                formik.values.beneficiars_gifts_id
                              )
                            }
                            className="px-4 py-2 text-sm sm:text-base text-black border border-[#240642] font-semibold rounded flex items-center gap-1 hover:bg-primary hover:text-white"
                          >
                            Remove gift
                          </button>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </form>
            </Modal>
          )}
        </>
      )}
    </>
  );
};

export default ListGiftCompo;
